import classNames from 'classnames';
import React from 'react';
import Link from 'next/link';
import { useIntl } from 'react-intl';
import { DateTime } from 'luxon';
import Icon from '../../../../atoms/icons/Icon';
import css from './MerchantBlogEntry.module.scss';
import { MerchantBlogEntry as BlogPost } from '../../../../interfaces/merchants/blogs';
import { buildSiteUrl } from 'src/utils/request-url';

interface Props {
  blogPost: BlogPost;
}

const MerchantBlogEntry: React.FC<Props> = ({ blogPost }) => {
  const intl = useIntl();
  const classes = classNames(css.MerchantBlogEntry);
  const url = buildSiteUrl(`/blogs/${blogPost.public_id}#pageContent`, 'next');
  const publishedAt = DateTime.fromSeconds(blogPost.published_at).toJSDate();

  return (
    <li className={classes}>
      <Link href={url} prefetch={false} className={css.MerchantBlogEntry__Link}>
        <span className={css.MerchantBlogEntry__Text}>
          <span className={css.MerchantBlogEntry__Date}>
            {intl.formatDate(publishedAt, {
              day: '2-digit',
              month: 'short',
              year: 'numeric',
            })}
          </span>
          <strong className={css.MerchantBlogEntry__Title}>
            {blogPost.name}
          </strong>
          <Icon className={css.MerchantBlogEntry__Icon} name="arrow-right" />
        </span>
        {blogPost.primary_image && (
          <img
            alt=""
            className={css.MerchantBlogEntry__Thumbnail}
            src={blogPost.primary_image.square.url}
          />
        )}
      </Link>
    </li>
  );
};

export default MerchantBlogEntry;
